import { lazy } from 'react';
// import { authRoles } from 'app/auth';

const AnalyticsDashboardAppConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  // auth: authRoles.admin, // ['admin']
  routes: [
    {
      path: '/dashboard',
      component: lazy(() => import('./dashboard')),
      title: 'Ana Sayfa',
      isAuthProtected: true
    }
  ]
};

export default AnalyticsDashboardAppConfig;
